import {Button, IconButton, Tooltip} from '@mui/material'
import {SearchItem} from '../../../model/SearchItem'
import {FileDownload} from '@mui/icons-material'
import React, {useState} from 'react'
import CustomDialog from '../../../../genericComponents/customDialog/CustomDialog'
import {BodySmall} from '../../../../genericComponents/typographie/UIKitV2/BodySmall'
import {useGetAllDisplaySetsQuery} from '../../../../displaySet/rtkDisplaySet'
import {DisplaySet} from '../../../../displaySet/model/DisplaySet'
import {DisplaySetsSelection} from '../../../../displaySet/componentRelatedToDisplaySet/DisplaySetsSelection'
import './ItemsExtraction.scss'
import {useExtractionItemsMutation} from './rtkExtractionItems'
import {useCurrentGuildContext} from '../../../../util/routing'

export const ItemsExtraction = ({selectedItems, isDisabled}: {
    selectedItems: SearchItem[],
    isDisabled: boolean,
}) => {
    const MAX_SELECTED_ITEMS = 5000
    const [currentGuildContext] = useCurrentGuildContext()
    const {data: displaySets, isLoading} = useGetAllDisplaySetsQuery()
    const [extractItems, extractItemsResult] = useExtractionItemsMutation()

    const [selectedDisplaySets, setSelectedDisplaySets] = useState<DisplaySet[]>([])
    const [extractionDialog, setExtractionDialog] = useState(false)

    const hasTooManySelectedItems = selectedItems.length > MAX_SELECTED_ITEMS
    const tooltipMessage = hasTooManySelectedItems ?
        `Extraction is limited to a maximum number of ${MAX_SELECTED_ITEMS} items each times` : 'Download selected items'

    const onSelectDisplaySet = (newDisplaySetSelected: DisplaySet[]) => {
        setSelectedDisplaySets(newDisplaySetSelected)
    }

    const handleExtraction = () => {
        if (!isExtractionEnabled) return
        const itemIds = selectedItems.map(item => item.id).sort()
        const displaySetIds = selectedDisplaySets.map(displaySets => displaySets.id).sort()
        extractItems({itemIds, displaySetIds, guildId: currentGuildContext?.guildId}).then(result => {
            if (!result.error) {
                setExtractionDialog(false)
            }
        })
    }

    const getCaption = () => {
        const numberOfItems = selectedItems.length
        return `${numberOfItems} item${numberOfItems > 1 ? 's' : ''}`
    }

    const isExtractionEnabled = selectedDisplaySets.length > 0 && selectedItems.length > 0 && !hasTooManySelectedItems

    return <>
        <Tooltip title={tooltipMessage}>
            <span>
                <IconButton
                    data-testid="download-button"
                    aria-label="download-item"
                    color="primary"
                    disabled={isDisabled || hasTooManySelectedItems}
                    onClick={() => setExtractionDialog(true)}
                >
                    <FileDownload/>
                </IconButton>
            </span>
        </Tooltip>
        <CustomDialog open={extractionDialog}
                      className={'extract-items-dialog'} title={'Extract Item Data'}
                      headerIcon={false}
                      caption={getCaption()}
                      onClose={() => setExtractionDialog(false)}>
            <BodySmall>
                You may select relevant <strong>display sets</strong> that you would like to include in the
                extraction of your selected items.
            </BodySmall>
            <div className="display-set-section">
                <BodySmall>Please select:</BodySmall>
                {displaySets && (
                    <DisplaySetsSelection
                        headerLabel={'Display Sets'}
                        displaySets={displaySets}
                        isLoading={isLoading}
                        onChange={(onSelectDisplaySet)}/>
                )}
            </div>
            <div>
                <BodySmall>
                    Extraction will be <strong>asynchronous</strong>, a download link will be sent to
                    the <strong>email</strong> linked to your account when the file is ready. Thank you for your
                    patience.
                </BodySmall>
            </div>
            <div className="dialog-footer">
                <Button disabled={!isExtractionEnabled || extractItemsResult.isLoading} variant="contained" data-testid="extract-button"
                        onClick={handleExtraction}>Extract</Button>
            </div>
        </CustomDialog>
    </>
}
